import { render, staticRenderFns } from "./EmptyTablePlaceholder.vue?vue&type=template&id=cc0070c6&scoped=true&"
import script from "./EmptyTablePlaceholder.vue?vue&type=script&lang=js&"
export * from "./EmptyTablePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./EmptyTablePlaceholder.vue?vue&type=style&index=0&id=cc0070c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0070c6",
  null
  
)

export default component.exports